import { defineComponent as u, createBlock as c, openBlock as l, withCtx as v, createCommentVNode as d, unref as e } from "vue";
import f from "../../components/ViewLayout/ViewLayoutSection.vue.js";
import { useActiveEntities as _ } from "../../store/active-entities.js";
import k from "./components/MarkdownInput.vue.js";
import { useWorkspace as V } from "../../store/store.js";
const M = /* @__PURE__ */ u({
  __name: "CollectionOverview",
  setup(C) {
    const {
      activeCollection: o,
      activeEnvironment: t,
      activeEnvVariables: s,
      activeWorkspace: n
    } = _(), { collectionMutators: m } = V(), p = (i) => {
      o.value && m.edit(o.value.uid, "info.description", i);
    };
    return (i, w) => (l(), c(f, null, {
      default: v(() => {
        var r, a;
        return [
          e(t) && e(n) ? (l(), c(k, {
            key: 0,
            envVariables: e(s),
            environment: e(t),
            modelValue: ((a = (r = e(o)) == null ? void 0 : r.info) == null ? void 0 : a.description) ?? "",
            workspace: e(n),
            "onUpdate:modelValue": p
          }, null, 8, ["envVariables", "environment", "modelValue", "workspace"])) : d("", !0)
        ];
      }),
      _: 1
    }));
  }
});
export {
  M as default
};
